import { v4 } from "uuid";

export function newUuid(): string {
  return v4();
}
